import React, { useEffect, useState } from "react";
import "../../Style/ListingProperty.css";
import { categoryListhomeAPI } from "../../API/CommanApi";
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

const Listingproperty = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const CustomNextArrow = (props) => {
    const { onClick } = props;
    return <FaChevronRight className="slider_Arrowr_right" onClick={onClick} />;
  };
  const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return <FaChevronLeft className="slider_Arrowr_left" onClick={onClick} />;
  };

  const [categrydata, setCategrydata] = useState([]);
  const navigation = useNavigate();
  useEffect(() => {
    categoryListhomeAPI((callback) => {
      setCategrydata(callback?.data?.categoryList);
    });
  }, []);
  return (
    <>
      <div className="Listingproperty">
        <div className="container-xxl p-0">
          <Slider
            {...settings}
            nextArrow={<CustomNextArrow />}
            prevArrow={<CustomPrevArrow />}
          >
            {categrydata?.map((iteam, i) => {
              const { title, id, image } = iteam;
              return (
                <div className="listing_box" key={i}>
                  <div
                    className="card"
                    onClick={() =>
                      navigation("/property-filters", {
                        state: { propertyTypekey: id, name: "Listingproperty" },
                      })
                    }
                  >
                    <div className="images">
                      <img src={image} alt="img" />
                    </div>
                    <div className="image_content d-flex justify-content-center align-items-center flex-column">
                      <h5 className="m-0">{title}</h5>
                      <span>
                        Learn More <FaChevronRight />
                      </span>
                    </div>
                    <div className="overlay">
                      <div className="text">
                        <h5 className="m-0">{title}</h5>
                        <p className="m-0">
                          Browse Our Neighborhood Guides Below.
                        </p>
                        <span>
                          Learn More <FaChevronRight />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Listingproperty;
